import { render, staticRenderFns } from "./VoucherDetailsSignatures.vue?vue&type=template&id=24972ec0&scoped=true"
import script from "./VoucherDetailsSignatures.vue?vue&type=script&lang=ts"
export * from "./VoucherDetailsSignatures.vue?vue&type=script&lang=ts"
import style0 from "./VoucherDetailsSignatures.vue?vue&type=style&index=0&id=24972ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24972ec0",
  null
  
)

export default component.exports